var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendReceiveDonationAgreement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Send_Receive_Donation_Agreement"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send_Receive_Donation_Agreement",
    "data-name": "Send/Receive Donation Agreement",
    clipPath: "url(#clip-Send_Receive_Donation_Agreement)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11795",
    "data-name": "Group 11795",
    transform: "translate(1.176 1.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11796",
    "data-name": "Group 11796",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22258",
    "data-name": "Path 22258",
    d: "M0,15.315V.336A.829.829,0,0,1,.306,0H8.437a1.3,1.3,0,0,1,.345.271q1.376,1.378,2.756,2.753a.631.631,0,0,1,.195.477q0,1.773,0,3.545v.217c.095-.09.161-.15.224-.213q.74-.739,1.479-1.48a.514.514,0,0,1,.378-.168,1.838,1.838,0,0,1,1.756,1.309.885.885,0,0,1-.178,1c-1.2,1.165-2.367,2.356-3.551,3.535a.338.338,0,0,0-.114.264c0,1.2,0,2.394,0,3.591a.481.481,0,0,1-.542.544q-5.271,0-10.543,0A.6.6,0,0,1,0,15.315M.916,7.824h0q0,3.37,0,6.74c0,.141.038.173.176.173q4.746-.006,9.491,0c.041,0,.082,0,.122,0,.069.006.1-.011.1-.091q-.006-1.185,0-2.369c0-.123-.038-.108-.119-.063a3.738,3.738,0,0,1-1.3.449,1.2,1.2,0,0,0-.522.137,2.735,2.735,0,0,1-1.617.4.8.8,0,0,1-.848-.857c0-.129-.061-.134-.151-.106a1.6,1.6,0,0,0-.565.353.449.449,0,0,1-.633-.018.457.457,0,0,1,0-.646A2,2,0,0,1,6.253,11.3c.533-.047,1.052.179,1.049.865,0,.079.021.107.1.1a2.741,2.741,0,0,0,.714-.129.33.33,0,0,0,.259-.333A3.5,3.5,0,0,1,9.235,9.8c.456-.528.977-1,1.466-1.493a.293.293,0,0,0,.1-.226q0-1.972,0-3.943c0-.269,0-.269-.263-.269-.718,0-1.437,0-2.155,0a.474.474,0,0,1-.521-.52c0-.754,0-1.508,0-2.262,0-.141-.036-.174-.175-.174q-3.3.006-6.6,0c-.135,0-.169.036-.169.17q.006,3.37,0,6.74m8.4,3.911a3.041,3.041,0,0,0,1.689-.952c.248-.263.51-.512.766-.768Q13.188,8.6,14.605,7.188a.226.226,0,0,0,.055-.293.974.974,0,0,0-.508-.5.219.219,0,0,0-.282.054c-.546.556-1.1,1.1-1.65,1.656-.741.743-1.487,1.48-2.218,2.233a2.644,2.644,0,0,0-.683,1.4m.748-8.8L8.773,1.663c0,.367,0,.777,0,1.188,0,.083.044.089.106.089h1.188",
    transform: "translate(0 0)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22259",
    "data-name": "Path 22259",
    d: "M14.923,38.667h3.438a.424.424,0,0,1,.4.224.463.463,0,0,1-.007.479.441.441,0,0,1-.412.214c-.693,0-1.385,0-2.078,0H11.516a.459.459,0,1,1,0-.917q1.7,0,3.408,0",
    transform: "translate(-9.07 -31.789)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22260",
    "data-name": "Path 22260",
    d: "M13.95,50.6c-.81,0-1.619,0-2.429,0a.452.452,0,0,1-.457-.607.469.469,0,0,1,.474-.311h4.781a.68.68,0,0,1,.2.012.468.468,0,0,1,.353.5.451.451,0,0,1-.46.4c-.82,0-1.639,0-2.459,0Z",
    transform: "translate(-9.076 -40.843)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22261",
    "data-name": "Path 22261",
    d: "M12.471,27.6c.341,0,.682-.008,1.023,0a.412.412,0,0,1,.4.322.462.462,0,0,1-.182.51.5.5,0,0,1-.288.083c-.636,0-1.273,0-1.909,0a.47.47,0,0,1-.487-.463.452.452,0,0,1,.47-.459c.325-.01.651,0,.977,0V27.6",
    transform: "translate(-9.063 -22.68)",
    fill: "#0072ce",
    stroke: "#0072ce",
    strokeWidth: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendReceiveDonationAgreement);
export default __webpack_public_path__ + "static/media/Send-Receive Donation Agreement.7d4e507c67217c7d5202d4cef47b8b21.svg";
export { ForwardRef as ReactComponent };